import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ClickAwayListener, Grow, Paper, Popper } from "@mui/material";
import Avatar from "@mui/material/Avatar/Avatar";
import { styled } from "@mui/material/styles";
import { useState } from "react";
import BryxColors from "../types/theme";
import BryxBox from "./BryxBox";
import BryxButton from "./BryxButton";
import BryxIcon from "./BryxIcon/BryxIcon";
import BryxTypography from "./BryxTypography";
const CustomButton = styled(({ name, onClick }) => {
    return (_jsx(BryxButton, { variant: "text", onClick: onClick, children: _jsx(BryxTypography, { variant: "body1", children: name }) }));
})(({ theme }) => {
    const mode = theme.palette.mode;
    return {
        height: "42px",
        width: "151px",
        padding: "0px !important",
        justifyContent: "flex-start",
        ":hover": {
            "& .MuiTypography-root": {
                color: BryxColors.brand1("light"),
            },
        },
        "& .MuiTypography-root": {
            color: BryxColors.notify("light", "inactive"),
            marginLeft: "8px",
        },
    };
});
const BryxAccountDropdown = styled(({ initials, items, ...rest }) => {
    const [open, setOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (e) => {
        setOpen((prev) => !prev);
        setAnchorEl(e.currentTarget);
    };
    const handleClickAway = () => {
        setOpen(false);
    };
    return (_jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsx("div", { children: _jsxs(BryxButton, { ...rest, sx: { alignItems: "center", flexDirection: "row" }, onClick: handleClick, children: [_jsx(Avatar, { children: initials }), _jsx(BryxIcon, { iconName: "keyboard_arrow_down", fontSize: "medium", sx: {
                            transform: open ? "rotate(180deg)" : "rotate(0deg)",
                            fill: open ? `${BryxColors.brandDark2("light")} !important` : undefined,
                        }, lgIconSize: true }), _jsx(Popper, { open: open, anchorEl: anchorEl, placement: "bottom-end", sx: { zIndex: 5 }, transition: true, children: ({ TransitionProps }) => (_jsx(ClickAwayListener, { onClickAway: () => setOpen(false), children: _jsx(Grow, { ...TransitionProps, style: { transformOrigin: "top center" }, timeout: 281, children: _jsx(Paper, { children: _jsx(BryxBox, { isFlex: true, fullWidth: true, sx: {
                                            py: 2,
                                            px: 1,
                                            borderRadius: "4px",
                                            marginTop: "8px",
                                            paddingTop: "8px",
                                            paddingBottom: "8px",
                                            flexDirection: "column",
                                            width: "167px",
                                            minHeight: "42px",
                                            overflow: "auto",
                                            scrollbarWidth: "none",
                                            msOverflowStyle: "none",
                                            "&::-webkit-scrollbar": { display: "none" },
                                            rowGap: "0px",
                                        }, children: items?.map((item) => {
                                            return (_jsx(CustomButton, { name: item.name, onClick: item.onClick }, item.name + item.onClick.toString()));
                                        }) }) }) }) })) })] }) }) }));
})(({ theme }) => {
    const mode = theme.palette.mode;
    return {
        "& .MuiAvatar-root": {
            backgroundColor: BryxColors.brand1(mode),
            marginRight: "8px",
            height: "32px",
            width: "32px",
            fontSize: "13px",
        },
        "& .MuiSvgIcon-root": {
            fill: BryxColors.notify(mode, "inactive"),
            transition: "transform 250ms",
        },
        ":hover": {
            backgroundColor: "transparent",
            "& .MuiSvgIcon-root": {
                fill: `${BryxColors.brand1(mode)} !important`,
            },
        },
    };
});
export default BryxAccountDropdown;
